import type { RefComponent } from '@/types'

import { ref } from 'vue'
import { isEmpty, isNotEmpty, isRecord, prepareAnyUrl } from '@/helpers'

export const useFieldHandlers = (props: any) => {
  const wrapperRef: RefComponent<typeof HTMLDivElement> = ref(null)
  const inputRef: RefComponent<typeof HTMLInputElement> = ref(null)
  const placeholderRef: RefComponent<typeof HTMLDivElement> = ref(null)

  function focus() {
    wrapperRef.value?.classList.add('active')
  }

  function blur() {
    if (
      (isRecord(props.modelValue) && !isEmpty(props.modelValue)) ||
      isNotEmpty(props.modelValue) ||
      props.type === 'date' ||
      props.type === 'datetime-local'
    )
      return

    wrapperRef.value?.classList.remove('active')
  }

  function navigate() {
    if (
      (isRecord(props.modelValue) && isEmpty(props.modelValue)) ||
      !isNotEmpty(props.modelValue)
    )
      return

    window.open?.(prepareAnyUrl(props.modelValue), '_blank')?.focus()
  }

  return {
    wrapperRef,
    inputRef,
    placeholderRef,
    focus,
    blur,
    navigate,
  }
}
